import { transient, autoinject } from "aurelia-framework";
//import { RightShipQiRouterConstants } from "../../../../configuration/rightshipqi-router.constants";

@autoinject
@transient()
export class MyFleetCoachmark {
    
    //public group: string = RightShipQiRouterConstants.RouteNames.MyFleet;

}